import React from 'react';
import './CompanyStrategy.css';

function DataManagementSOP() {
  return (
    <div className="document-section">
      <h2>Data Management SOP</h2>
      <iframe
        src="/pdfs/nesim-data-management-sop.pdf"
        title="Data Management SOP"
        width="100%"
        height="800px"
        style={{ border: 'none' }}
      ></iframe>
    </div>
  );
}

export default DataManagementSOP;
